export default __webpack_public_path__ + "static/media/copy-outline-16-px.39dbf68f.svg";